export const SET_MODULECLE_CONTENT_LOADING = "SET_MODULECLE_CONTENT_LOADING";
export const SET_MODULECLE_CONTENT_ERROR = "SET_MODULECLE_CONTENT_ERROR";
export const CLEAR_MODULECLE_CONTENT_ERROR = "CLEAR_MODULECLE_CONTENT_ERROR";
export const CLEAR_MODULECLE_CONTENT_MESSAGE = "CLEAR_MODULECLE_CONTENT_MESSAGE";
export const CLEAR_CURRENT_MODULECLE_CONTENT = "CLEAR_CURRENT_MODULECLE_CONTENT";

export const GET_MODULECLE_CONTENTS_REQUEST = "GET_MODULECLE_CONTENTS_REQUEST";
export const GET_MODULECLE_CONTENTS_SUCCESS = "GET_MODULECLE_CONTENTS_SUCCESS";
export const GET_MODULECLE_CONTENTS_FAIL = "GET_MODULECLE_CONTENTS_FAIL";

export const GET_MODULECLE_CONTENT_REQUEST = "GET_MODULECLE_CONTENT_REQUEST";
export const GET_MODULECLE_CONTENT_SUCCESS = "GET_MODULECLE_CONTENT_SUCCESS";
export const GET_MODULECLE_CONTENT_FAIL = "GET_MODULECLE_CONTENT_FAIL";

export const CREATE_MODULECLE_CONTENT_REQUEST = "CREATE_MODULECLE_CONTENT_REQUEST";
export const CREATE_MODULECLE_CONTENT_SUCCESS = "CREATE_MODULECLE_CONTENT_SUCCESS";
export const CREATE_MODULECLE_CONTENT_FAIL = "CREATE_MODULECLE_CONTENT_FAIL";

export const UPDATE_MODULECLE_CONTENT_REQUEST = "UPDATE_MODULECLE_CONTENT_REQUEST";
export const UPDATE_MODULECLE_CONTENT_SUCCESS = "UPDATE_MODULECLE_CONTENT_SUCCESS";
export const UPDATE_MODULECLE_CONTENT_FAIL = "UPDATE_MODULECLE_CONTENT_FAIL";

export const DELETE_MODULECLE_CONTENT_REQUEST = "DELETE_MODULECLE_CONTENT_REQUEST";
export const DELETE_MODULECLE_CONTENT_SUCCESS = "DELETE_MODULECLE_CONTENT_SUCCESS";
export const DELETE_MODULECLE_CONTENT_FAIL = "DELETE_MODULECLE_CONTENT_FAIL";

export const REORDER_MODULECLE_CONTENTS_REQUEST = "REORDER_MODULECLE_CONTENTS_REQUEST";
export const REORDER_MODULECLE_CONTENTS_SUCCESS = "REORDER_MODULECLE_CONTENTS_SUCCESS";
export const REORDER_MODULECLE_CONTENTS_FAIL = "REORDER_MODULECLE_CONTENTS_FAIL";

export const setModuleCleContentLoading = (payload) => ({
    type: SET_MODULECLE_CONTENT_LOADING,
    payload,
});

export const setModuleCleContentError = (payload) => ({
    type: SET_MODULECLE_CONTENT_ERROR,
    payload,
});

export const clearModuleCleContentError = () => ({
    type: CLEAR_MODULECLE_CONTENT_ERROR,
});

export const clearModuleCleContentMessage = () => ({
    type: CLEAR_MODULECLE_CONTENT_MESSAGE,
});

export const clearCurrentModuleCleContent = () => ({
    type: CLEAR_CURRENT_MODULECLE_CONTENT,
});

export const getModuleCleContentsRequest = (moduleCleId) => ({
    type: GET_MODULECLE_CONTENTS_REQUEST,
    payload: { moduleCleId },
});

export const getModuleCleContentsSuccess = (moduleCleId, items) => ({
    type: GET_MODULECLE_CONTENTS_SUCCESS,
    payload: { moduleCleId, items },
});

export const getModuleCleContentsFail = (payload) => ({
    type: GET_MODULECLE_CONTENTS_FAIL,
    payload,
});

export const getModuleCleContentRequest = (moduleCleId, contentId) => ({
    type: GET_MODULECLE_CONTENT_REQUEST,
    payload: { moduleCleId, contentId },
});

export const getModuleCleContentSuccess = (payload) => ({
    type: GET_MODULECLE_CONTENT_SUCCESS,
    payload,
});

export const getModuleCleContentFail = (payload) => ({
    type: GET_MODULECLE_CONTENT_FAIL,
    payload,
});

export const createModuleCleContentRequest = (moduleCleId, payload, file = null, callbacks = {}) => ({
    type: CREATE_MODULECLE_CONTENT_REQUEST,
    payload: { moduleCleId, payload, file, callbacks },
});

export const createModuleCleContentSuccess = (payload) => ({
    type: CREATE_MODULECLE_CONTENT_SUCCESS,
    payload,
});

export const createModuleCleContentFail = (payload) => ({
    type: CREATE_MODULECLE_CONTENT_FAIL,
    payload,
});

export const updateModuleCleContentRequest = (moduleCleId, contentId, payload, file = null, callbacks = {}) => ({
    type: UPDATE_MODULECLE_CONTENT_REQUEST,
    payload: { moduleCleId, contentId, payload, file, callbacks },
});

export const updateModuleCleContentSuccess = (payload) => ({
    type: UPDATE_MODULECLE_CONTENT_SUCCESS,
    payload,
});

export const updateModuleCleContentFail = (payload) => ({
    type: UPDATE_MODULECLE_CONTENT_FAIL,
    payload,
});

export const deleteModuleCleContentRequest = (moduleCleId, contentId, callbacks = {}) => ({
    type: DELETE_MODULECLE_CONTENT_REQUEST,
    payload: { moduleCleId, contentId, callbacks },
});

export const deleteModuleCleContentSuccess = (payload) => ({
    type: DELETE_MODULECLE_CONTENT_SUCCESS,
    payload,
});

export const deleteModuleCleContentFail = (payload) => ({
    type: DELETE_MODULECLE_CONTENT_FAIL,
    payload,
});

export const reorderModuleCleContentsRequest = (moduleCleId, sectionId, orderedContentIds, callbacks = {}) => ({
    type: REORDER_MODULECLE_CONTENTS_REQUEST,
    payload: { moduleCleId, sectionId, orderedContentIds, callbacks },
});

export const reorderModuleCleContentsSuccess = (moduleCleId, items) => ({
    type: REORDER_MODULECLE_CONTENTS_SUCCESS,
    payload: { moduleCleId, items },
});

export const reorderModuleCleContentsFail = (payload) => ({
    type: REORDER_MODULECLE_CONTENTS_FAIL,
    payload,
});
